<template>
  <v-card class="ma-1">
    <div class="d-flex align-items-center gap-2">
      <v-btn
        icon
        to="/utils"
        class="mr-2 ml-1"
        title="Back to Utilities"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-switch
        v-model="switchMode"
        :label="this.switchMode ? 'Group by Data Source Name' : 'Group by Annotation Heading Name'"
        @change="init()"
      />
    </div>

    <v-row
      v-if="warning"
      style="color: red; font-size: larger"
    >
      {{ warning }}
    </v-row>
    <b-form-input
      v-model="listFilter"
      :placeholder="this.switchMode ? 'Filter Data Sources by name' : 'Filter Annotation Headings by name'"
      class="mb-2"
      type="text"
    />

    <b-table
      v-if="this.switchMode"
      :fields="[
        { key: 'name', label: 'Data Source Name' },
        { key: 'substanceCount', label: 'Live Substances' },
        { key: 'annotationCount', label: 'Annotations' },
      ]"
      :items="listDataSources"
    >
      <template #cell(name)="data">
        {{ data.item.name }}
        <v-progress-linear
          v-if="data.item.uploading"
          indeterminate
        />
      </template>

      <template #cell(substanceCount)="data">
        <a
          href="javascript:void(0);"
          @click="substance(data.item)"
        >
          {{ data.item.substanceCount }}
        </a>
      </template>

      <template #cell(annotationCount)="data">
        <v-container>
          <v-row>
            {{ data.item.annotationCount }}
            <a
              v-if="data.item.annotations.length > 1"
              href="javascript:void(0);"
              @click="annotation2(data.item, data.item.name, '')"
            >
              (download all)
            </a>
          </v-row>

          <v-row
            v-for="i in data.item.annotations"
            :key="i"
          >
            <a
              href="javascript:void(0);"
              @click="annotation2(data.item, data.item.name, i)"
            >
              {{ i }}
            </a>
          </v-row>
        </v-container>
      </template>
    </b-table>
    <b-table
      v-if="!this.switchMode"
      :fields="[
        { key: 'name', label: 'Annotation Heading Name' },
        { key: 'dsName', label: 'Data Sources Name' },
      ]"
      :items="listDataSources"
    >
      <template #cell(name)="data">
        {{ data.item.name }}
        <v-progress-linear
          v-if="data.item.uploading"
          indeterminate
        />
      </template>

      <template #cell(dsName)="data">
        <v-container>
          <v-row
            v-for="i in data.item.annotations"
            :key="i"
          >
            <a
              href="javascript:void(0);"
              @click="annotation2(data.item, i, data.item.name)"
            >
              {{ i }}
            </a>
          </v-row>
          <v-row v-if="data.item.annotations.length > 1">
            <a
              href="javascript:void(0);"
              @click="annotation2(data.item, '', data.item.name)"
            >
              (download all)
            </a>
          </v-row>
        </v-container>
      </template>
    </b-table>
  </v-card>
</template>
<script>
import DialogBase from '@/components/dialogs/DialogBase.vue'
import { download, getErrorMessage, RESOLVER_URL } from '@/main'

export default {
  mixins: [DialogBase],

  props: {
    warning: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    switchMode: true,
    dataSources: [],
    listFilter: null,
  }),

  computed: {
    listDataSources() {
      return this.dataSources == null
        ? []
        : this.listFilter
          ? this.dataSources.filter((l) => l.name.toLowerCase().includes(this.listFilter.toLowerCase()))
          : this.dataSources
    },
  },

  watch: {},

  methods: {
    substance(item) {
      item.uploading = true
      this.$axios
        .get(`${RESOLVER_URL}/getsubstance?name=${item.name}`, {
          responseType: 'blob',
        })
        .then((response) => {
          download(item.name + '_substance.xlsx', response.data, 'xlsx')
          item.uploading = false
        })
        .catch((error) => {
          this.warning = getErrorMessage(error)
        })
    },
    annotationslist(a, item) {
      this.$axios
        .get(`${RESOLVER_URL}/getannotationslist?name=${item.name}`)
        .then((response) => {
          item.annotations = response.data
        })
        .catch((error) => {
          this.warning = getErrorMessage(error)
        })
    },
    annotation2(item, ds, annot) {
      item.uploading = true
      this.$axios
        .get(`${RESOLVER_URL}/getannotation?name=${ds}&heading=${annot}`, {
          responseType: 'blob',
        })
        .then((response) => {
          download(ds + '_' + annot + '_annotation.xlsx', response.data, 'xlsx')
          item.uploading = false
        })
        .catch((error) => {
          this.warning = getErrorMessage(error)
        })
    },
    init() {
      this.$axios
        .get(this.switchMode ? `${RESOLVER_URL}/getdatasources` : `${RESOLVER_URL}/getallannotations`)
        .then((response) => {
          this.warning = null
          this.dataSources = response.data
        })
        .catch((error) => {
          this.warning = 'loading error: ' + getErrorMessage(error)
        })
    },
  },

  mounted() {
    this.init()
  },
}
</script>
